export default __webpack_public_path__ + "static/media/free3.ea5cde40.png";